import React, { useState } from 'react';
import { ArrowLeftIcon, MenuIcon, XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function FontTestPage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <div className="w-full bg-white" data-id="element-1943" data-mp="2txza195bhodo">
      {/* Replica Font Styles */}
      <style data-id="element-1944" data-mp="2u021lxm4bpki">
        {`
          @import url('https://fonts.cdnfonts.com/css/replica-2');
          .replica-font {
            font-family: 'Replica', sans-serif;
          }
        `}
      </style>
      {/* Back button */}
      <div className="max-w-7xl mx-auto px-6 py-8" data-id="element-1945" data-mp="2f8tfhyhfcmc4">
        <Link to="/" className="flex items-center text-gray-600 hover:text-gray-900" data-id="element-1946" data-mp="2f9mc46mo5vgj">
          <ArrowLeftIcon size={20} className="mr-2" data-id="element-1947" data-mp="2a7x28ub6nnu1" />
          <span data-id="element-1948" data-mp="268ob7x7j2426">Go Back</span>
        </Link>
      </div>
      {/* Header with Replica Font */}
      <header className="w-full bg-white py-4 px-6 md:px-12 border-b border-gray-100" data-id="element-1949" data-mp="2191tpbko21nk">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-1950" data-mp="3yat1iudbz0y">
          <div className="flex items-center" data-id="element-1951" data-mp="8pj1abjypecj">
            <a href="/" className="no-underline" data-id="element-1952" data-mp="8qaytrx4dm5g">
              <img src="https://cdn.magicpatterns.com/uploads/8EVxVy8dkAVEdmFcPkswyr/Caveo_2026_Logo.png" alt="Caveo Logo" className="h-8 md:h-10" data-id="element-1953" data-mp="3r3ikha7xbzzi" />
            </a>
          </div>
          <nav className="hidden md:flex space-x-6" data-id="element-1954" data-mp="mqder8lva5i2">
            <a href="/product" className="text-[#3d3d3d] no-underline hover:text-[#138091] replica-font" data-id="element-1955" data-mp="mnhbd4r92om8">
              Product
            </a>
            <a href="/about-us" className="text-[#3d3d3d] no-underline hover:text-[#138091] replica-font" data-id="element-1956" data-mp="dqq92am3udj7">
              About Us
            </a>
            <a href="/resources" className="text-[#3d3d3d] no-underline hover:text-[#138091] replica-font" data-id="element-1957" data-mp="2ydjoeuvbb2lc">
              Resources
            </a>
          </nav>
          <div className="hidden md:flex items-center space-x-4" data-id="element-1958" data-mp="18wy0h5ydps8a">
            <a href="/login" className="text-[#3d3d3d] no-underline hover:text-[#138091] px-4 py-2 rounded-md replica-font" data-id="element-1959" data-mp="13zo04v9gbw5o">
              Login
            </a>
            <a href="/signup" className="bg-[#138091] text-white px-4 py-2 rounded-md font-medium no-underline hover:bg-[#3ab0bb] transition-colors replica-font" data-id="element-1960" data-mp="v59jopd6qfkz">
              Start Now
            </a>
          </div>
          <div className="md:hidden" data-id="element-1961" data-mp="g91zvq5ovg68">
            <button onClick={toggleMenu} className="text-[#3d3d3d] focus:outline-none" data-id="element-1962" data-mp="ga3hyel4h2xg">
              {isMenuOpen ? <XIcon size={24} data-id="element-1963" data-mp="c9tbz1xbycil" /> : <MenuIcon size={24} data-id="element-1964" data-mp="2amt8qng71w0m" />}
            </button>
          </div>
        </div>
        {/* Mobile menu */}
        {isMenuOpen && <div className="md:hidden fixed inset-0 z-50 bg-white pt-20 px-6" data-id="element-1965" data-mp="26msv350x5oum">
            <div className="flex flex-col space-y-4" data-id="element-1966" data-mp="3ojw8y0t6g2j5">
              <a href="/product" className="text-[#3d3d3d] text-xl py-2 no-underline hover:text-[#138091] replica-font" onClick={toggleMenu} data-id="element-1967" data-mp="3oha263e41r1z">
                Product
              </a>
              <a href="/about-us" className="text-[#3d3d3d] text-xl py-2 no-underline hover:text-[#138091] replica-font" onClick={toggleMenu} data-id="element-1968" data-mp="6425lq1rpst5">
                About Us
              </a>
              <a href="/resources" className="text-[#3d3d3d] text-xl py-2 no-underline hover:text-[#138091] replica-font" onClick={toggleMenu} data-id="element-1969" data-mp="3al6cmne6m6vu">
                Resources
              </a>
              <div className="pt-4 flex flex-col space-y-4" data-id="element-1970" data-mp="tto4ece8a60m">
                <a href="/login" className="text-[#3d3d3d] text-center py-2 border border-gray-200 rounded-md no-underline hover:text-[#138091] replica-font" onClick={toggleMenu} data-id="element-1971" data-mp="ytsk407bawps">
                  Login
                </a>
                <a href="/signup" className="bg-[#138091] text-white text-center py-2 rounded-md font-medium no-underline hover:bg-[#3ab0bb] transition-colors replica-font" onClick={toggleMenu} data-id="element-1972" data-mp="16dbmzr02nkpa">
                  Start Now
                </a>
              </div>
            </div>
          </div>}
      </header>
      {/* Hero Section with Replica Font */}
      <section className="w-full bg-[#f0f7f8] py-16 md:py-24" data-id="element-1973" data-mp="1q1kgc4dcpwqd">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-1974" data-mp="1l27sphenolmq">
          <div className="flex flex-col items-center text-center max-w-3xl mx-auto" data-id="element-1975" data-mp="1l2pxx3jaqa6s">
            <div className="inline-block bg-[#e6f3f5] text-[#108194] px-4 py-1 rounded-full text-sm font-medium mb-8 replica-font" data-id="element-1976" data-mp="1z30os6klvory">
              <span className="flex items-center" data-id="element-1977" data-mp="1u0t7r2kx5iir">
                <span className="mr-2" data-id="element-1978" data-mp="2doelobx5f08t">🚀</span>
                Launching the future of family cyber security
              </span>
            </div>
            <h1 className="mb-6 text-5xl md:text-6xl lg:text-7xl font-bold text-[#1b2f24] leading-tight replica-font" data-id="element-1979" data-mp="2ilohc9b4s853">
              Protect your family from digital chaos
            </h1>
            <div className="mb-10 max-w-2xl mx-auto" data-id="element-1980" data-mp="28nrx8s07u2uu">
              <p className="text-gray-700 text-lg replica-font" data-id="element-1981" data-mp="1uxojkpfejhh0">
                Take our free digital safety assessment to see where your
                <br data-id="element-1982" data-mp="1zqhnxc6yknsk" />
                family's at risk and how you can fix it. No email required.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row items-center gap-4 mb-12" data-id="element-1983" data-mp="1pz3fug0xyfnt">
              <a href="#" className="bg-[#108194] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 no-underline hover:bg-[#0e6d7c] replica-font" data-id="element-1984" data-mp="1px0sk3r6b0ms">
                <span data-id="element-1985" data-mp="3inb7epcudc60">Start Now</span>
                <ArrowLeftIcon className="transform rotate-180" size={18} data-id="element-1986" data-mp="3iocs7ljntd0x" />
              </a>
              <a href="#" className="border border-[#138091] text-[#138091] px-6 py-3 rounded-md font-medium no-underline hover:bg-[#f0f7f8] transition-colors replica-font" data-id="element-1987" data-mp="3dw2u3i8e56nk">
                Learn More
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* Font Information Section */}
      <section className="w-full bg-white py-16 px-6" data-id="element-1988" data-mp="i7x8q80q9yq">
        <div className="max-w-3xl mx-auto" data-id="element-1989" data-mp="ircu0a74m9l">
          <h2 className="text-3xl font-bold mb-6 text-center replica-font" data-id="element-1990" data-mp="3sl93u04uuf9p">
            About Replica Font
          </h2>
          <div className="bg-gray-50 p-6 rounded-lg shadow-sm" data-id="element-1991" data-mp="3nlmfaujktcll">
            <p className="mb-4 replica-font" data-id="element-1992" data-mp="2h6lot4dblmme">
              Replica is a neo-grotesque sans-serif typeface that offers a
              clean, modern aesthetic with excellent readability. It features
              balanced proportions and a neutral character that makes it
              versatile for both display and body text.
            </p>
            <p className="mb-4 replica-font" data-id="element-1993" data-mp="wpcnbz3cjhbe">Key characteristics:</p>
            <ul className="list-disc pl-6 space-y-2 mb-6" data-id="element-1994" data-mp="10pmp0zk3vlkg">
              <li className="replica-font" data-id="element-1995" data-mp="10o1xlit38iqt">Clean, geometric structure</li>
              <li className="replica-font" data-id="element-1996" data-mp="15ifvbrv831yn">
                Good readability at various sizes
              </li>
              <li className="replica-font" data-id="element-1997" data-mp="1afpuw0cbsu07">Modern, professional appearance</li>
              <li className="replica-font" data-id="element-1998" data-mp="1fdra2a6ms96e">
                Works well for digital interfaces
              </li>
            </ul>
            <div className="pt-4 border-t border-gray-200" data-id="element-1999" data-mp="1kc160n06jdt2">
              <p className="text-sm text-gray-500 replica-font" data-id="element-2000" data-mp="1oepir5s0l4vb">
                Note: This is a font test page to evaluate how Replica would
                look on the Caveo website.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}